<template>
    <li :class="item.class">
        <span class="clearfix">
            <span class="icon"><img :src="'../../images/icons/' + item.icon"></span>
            <span class="time">{{ item.time }}</span>
            <span class="entry"><span v-if="item.heading.length > 0">{{ item.heading }}</span>{{ item.comment }}</span>
        </span>
    </li>
</template>

<script>
    export default {
        props: ['item'],
        mounted() {
            window.dispatchEvent(new Event('resize'));
        },
    }
</script>
